import { render, staticRenderFns } from "./Feature8.vue?vue&type=template&id=e59a245e&scoped=true&"
import script from "./Feature8.vue?vue&type=script&lang=js&"
export * from "./Feature8.vue?vue&type=script&lang=js&"
import style0 from "./Feature8.vue?vue&type=style&index=0&id=e59a245e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a245e",
  null
  
)

export default component.exports